import type { StatusChipVariant } from '@/components/ui/status-chip';

// Canonical status→chip-variant helpers for the brokers feature.
// transactionStatusVariant is the SUPERSET version — the detail page
// should import this helper instead of re-declaring its own variant.

const TRANSACTION_STATUS_VARIANTS: Record<string, StatusChipVariant> = {
  COMPLETED: 'success', // the only final state — funds settled
  CREDITED: 'info', // funds moved but not yet settled; not final, must not read as green
  SUCCESS: 'success',
  PENDING: 'warning',
  PROCESSING: 'warning',
  FAILED: 'destructive',
  REJECTED: 'destructive',
};

export const transactionStatusVariant = (status: string): StatusChipVariant => TRANSACTION_STATUS_VARIANTS[status.toUpperCase()] ?? 'muted';

// OPEN maps to the app's blue/primary chip; fallback grey for unknown statuses.
const BATCH_STATUS_VARIANTS: Record<string, StatusChipVariant> = {
  OPEN: 'info',
  NOTIFIED: 'warning',
  SETTLED: 'success',
  FAILED: 'destructive',
};

export const batchStatusVariant = (status: string): StatusChipVariant => BATCH_STATUS_VARIANTS[status.toUpperCase()] ?? 'muted';
